import React, { Component } from "react";
import ContentWrapper from "../../../Layout/ContentWrapper";
import axios from "../../../../services/axios";
import { Container, Card, CardHeader, CardBody, CardTitle, Button } from "reactstrap";
import $ from "jquery";
import { AuthService } from '../../../../services';
import {Redirect} from 'react-router-dom';
import Moment from "moment"
import { Fragment } from "react";
import ReactDatatable from '@ashvin27/react-datatable';
import NumberFormat from 'react-number-format'


class UserSelfManagement extends Component {
  state = {
    usersList: {}
  };

  componentDidMount() {
    const isAuthenticated = AuthService.isAuthenticated();
    if (!isAuthenticated) {
      this.setState({ redirect: "/login" })
    }

  this.GetAllUser();
  }

  AddNewUser = () => {
    return this.props.history.push('/admin-add-new-user')
}


GetAllUser=()=>{
  axios.get("/users/list")
  .then(res => {
    const response = res.data;
    this.setState({ usersList: response })
    console.log(response);
  })
}


AddActionButtonStyle={
  color:'white',
  background:"#003366"
}



EditUser=(record)=>{
  console.log("am here")
  return this.props.history.push('/admin-self-edit/' + record.id,record)
}

formatDate = (date) => {
  return Moment(date).format('lll')
}

  columns = [
    {
      key: "id",
      text: "#",
      sortable: true,
      cell: (record, index) => {
        return index += 1;
      }
    },
    {
      key: "fullName",
      text: "FULL NAME"
    },
    {
      key: "username",
      text: "USERNAME"
    },
    {
      key: "roleName",
      text: "ROLE"
    },

    {
      key: "userMonthlySmsLimit",
      text: "SMS MONTHLY LIMIT",
      cell: (record, index) => {
        return (<NumberFormat value={record.userMonthlySmsLimit} displayType={'text'} thousandSeparator={true} prefix={''} />)
      }
    },

    {
      key: "isActive",
      text: "STATUS",
      sortable: true,
      cell: (record, index) => {
        if (record.isActive == 1) {
          return (
            <span className="badge badge-success">Active</span>
          );
        }
        if (record.isActive != 1) {
          return (<span className="badge badge-danger">Disabled</span>);
        }
      }
    },
    {
      key: "lastLogin",
      text: "LAST LOGIN",
      cell: (record, index) => {
        if (record.lastLogin == null) {
          return "N/A"
        } else {
          return (this.formatDate(record.lastLogin))
        }
      }

    },
    {
      key: "createdAt",
      text: "DATE CREATED",
      sortable: true,
      cell: (record, index) => {
        return (this.formatDate(record.registrationDate))
      }
    },
    {
      key: "isActive",
      text: "ACTION",
      cell: (record, index) => {
          return (
            <Fragment>
              <span className="btn badge-success mr-2  px-4" onClick={() => this.EditUser(record)}> <i className="icon-pencil mr-2"  ></i>Edit</span>
            </Fragment>
          )
      
      }
    }
  ];


  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect}/>
  }
    return (
      <ContentWrapper>
        <div className="content-heading">
          <div className="mr-auto flex-row">
            Account Management
            <small>Admin self management.</small>
          </div>
          <div className="flex-row">
           
          </div>
        </div>
        <Container fluid>
          <Card>
            <CardBody>
              <ReactDatatable
                extraButtons={this.extraButtons}
                config={this.config}
                records={this.state.usersList}
                columns={this.columns}
              />
            </CardBody>
          </Card>
        </Container>
      </ContentWrapper>
    );
  }
}

export default UserSelfManagement;
